<app-modal [open]="active" [name]="'atp-sign-accepted'" (close)="closeDialog()">
  <div modal-header>{{ modalHeaderTitle }}</div>
  <div modal-body>{{ modalBody }}{{ siteVisitOfferSentence }}</div>

  <!--
    All three buttons stay DIRECT children of <app-modal>: content projection
    matches `select="[modal-footer]"` against direct children only, so wrapping
    them in an <ng-container>/<ng-template> would drop them through the bare
    <ng-content> into `.modal__body`. A structural directive on the button
    ITSELF is fine — the element's static attributes are hoisted onto the
    generated template node, so `modal-footer` still matches.

    Emphasis is class-bound rather than duplicated across two branches, which
    makes the empty-list rendering (View Active Projects primary, Back
    secondary — exactly what shipped before the scheduling offer) structural
    instead of something a second copy of the markup has to keep in step.
  -->
  <button
    *ngIf="siteVisits.length > 0"
    modal-footer
    type="button"
    class="btn btn--primary"
    routerLink="/scheduling"
    [queryParams]="scheduleSiteVisitsQueryParams"
    routerLinkActive="router-link-active"
    data-testid="atp-sign-accepted-schedule-site-visits"
    (click)="closeDialog()"
  >
    {{ scheduleSiteVisitsLabel }}
  </button>
  <button
    modal-footer
    type="button"
    class="btn"
    [class.btn--primary]="siteVisits.length === 0"
    [class.btn--secondary]="siteVisits.length > 0"
    routerLink="/active"
    routerLinkActive="router-link-active"
    data-testid="atp-sign-accepted-view-active-projects"
    (click)="closeDialog()"
  >
    View Active Projects
  </button>
  <button
    modal-footer
    type="button"
    class="btn"
    [class.btn--secondary]="siteVisits.length === 0"
    [class.btn--link]="siteVisits.length > 0"
    data-testid="atp-sign-accepted-close"
    (click)="closeDialog()"
  >
    Back
  </button>
</app-modal>
